import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";

const screenHeight = typeof window !== "undefined" && window.innerHeight

class PipelineTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabItemComponent: [],
      selected: 0,
      tabFixed: false,
      tabChName: '',
      selectRecord: [0],  // 记录被点击过的Tab索引，未被记录的，对应Tab下的内容不加载
      reRender: false,
      isAndroid: utils.isAndroid()
    };
    this.isIframe = utils.getParams('isIframe') == 1;
    this.pipelineTabRef = null;
    this.tabItemRef = null;
    this.tabItemContentRef = null;
    this.tabItemPlaceholderRef = null;
    this.initSet = false;
    this.tabScrollTopMap = {};
    // 滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll',(e)=>{
        this.onScroll();
      });
    }
  }

  componentDidMount() {
    const { useTabContainerBgColor } = this.props.config.baseConfig;
    useTabContainerBgColor && this.modifyPageBackgroundColor();

    if (typeof window !== 'undefined' && window.parent && this.isIframe) {
      // 在iframe中打开，获取组件尺寸并发送后台编辑器
      utils.postComponentSizeToEditor();
    }
  }
  // 修改页面背景色
  modifyPageBackgroundColor = () => {
    const { grains } = this.props.config.containerConfig;
    if (grains && grains.length > 0) {
      const tabContainerBgColor = grains[this.state.selected].tabTitle.tabContainerBgColor;
      if (tabContainerBgColor) {
        document.querySelector('html').style.backgroundColor = tabContainerBgColor;
        document.querySelector('body').style.backgroundColor = tabContainerBgColor;
      }
    }
  }
  handleTabSelect = (event, item, index) => {
    event.preventDefault();
    if (index === this.state.selected) {
      return;
    }
    const { selectRecord = [0] } = this.state;
    const currentTabIndex = this.state.selected;
    const hasRecord = selectRecord.findIndex(item => item === index)
    const navigationBarHeight = this.props.navigationBarHeight;
    const { tabFixed } = this.state;
    const newProps = JSON.parse(JSON.stringify(this.props));
    let tabBarOffsetTop = 0;
    if (tabFixed) {
      tabBarOffsetTop = this.tabItemPlaceholderRef && this.tabItemPlaceholderRef.offsetTop;
    } else {
      tabBarOffsetTop = this.tabItemRef && this.tabItemRef.offsetTop;
    }
    Object.assign(newProps, {
      tabChName: item.tabTitle.tabName
    });
    utils.uploadTrack(newProps, {
      sort: index
    });
    if (hasRecord < 0) {
      selectRecord.push(index)
    }
    this.saveTabScrollTop(currentTabIndex);
    this.setState({
      selected: index,
      selectRecord,
      tabChName: item.tabTitle.tabName,
      reRender: true
    }, () => {
      this.restoreTabScrollTop(index, tabFixed && tabBarOffsetTop > 0 ? tabBarOffsetTop - navigationBarHeight + 1 : null);
      this.updateNavPostion();
    });
  }

  getPageScrollTop = () => {
    if (typeof window === 'undefined') {
      return 0;
    }
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  saveTabScrollTop = (tabIndex) => {
    if (typeof window === 'undefined') {
      return;
    }
    this.tabScrollTopMap[tabIndex] = this.getPageScrollTop();
  }

  restoreTabScrollTop = (tabIndex, fallbackScrollTop) => {
    if (typeof window === 'undefined') {
      return;
    }
    const savedScrollTop = this.tabScrollTopMap[tabIndex];
    const scrollTop = typeof savedScrollTop === 'number' ? savedScrollTop : fallbackScrollTop;
    if (typeof scrollTop !== 'number') {
      return;
    }
    window.requestAnimationFrame(() => {
      window.scrollTo(0, scrollTop);
    });
  }

  onScroll = () => {
    const navigationBarHeight = this.props.navigationBarHeight;
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const navOffsetTop = this.pipelineTabRef ? (this.pipelineTabRef.offsetTop - navigationBarHeight) : 0;
    const tabItem = this.tabItemRef;
    const tabItemContent = this.tabItemContentRef;
    const tabItemClientHeight = tabItem ? tabItem.clientHeight : 0;
    const bottomOffsetTop = tabItemContent ? (tabItemContent.offsetTop + tabItemContent.clientHeight) : 0;

    if (scrollHeight - navOffsetTop > 0 && scrollHeight < bottomOffsetTop - navigationBarHeight - tabItemClientHeight) {
      !this.state.tabFixed && this.setState({
        tabFixed: true,
        reRender: true
      });
    } else {
      this.state.tabFixed && this.setState({
        tabFixed: false,
        reRender: true
      });
    }

    // this.setNavigationBarHeight();
  }

  setNavigationBarHeight = () => {
    if (this.initSet) {
      return;
    }
    const allComponents = this.props.allComponents || [];
    const componentId = this.props['customAttributes'] ? this.props['customAttributes']['data-component-id'] : '';
    const componentIdx = allComponents.findIndex(item => item && item.id === componentId);
    const pipelineNavigationIdx = allComponents.findIndex(item => item && item.name === 'pipeline-navigation');
    const setHeight = () => {
      const navigationBar = document.querySelector('.navigation-bar-wrapper');
      if (navigationBar && this.tabItemRef) {
        window.navigationBarHeight = navigationBar.clientHeight + this.tabItemRef.clientHeight - 1.5;
        this.initSet = true;
      }
    }
    if (pipelineNavigationIdx >= 0) {
      if (componentIdx < pipelineNavigationIdx) {
        setHeight();
      } else {
        this.initSet = true;
      }
    } else {
      setHeight();
    }
  }

  updateNavPostion = () => {
    // 导航条切换选中后，调整当前导航到居中位置
    const navigationBar = document.querySelector('.tab-scroll');
    const checkedNavItem = document.querySelector(`.tab-item-nav-active`); // 当前选中的导航item
    const navWidth = navigationBar.offsetWidth; // 导航栏宽度
    const checkedItemOffsetLeft = checkedNavItem.offsetLeft; // 元素距离左边距离
    const checkedItemWidth = checkedNavItem.offsetWidth;
    // 需要滚动的距离
    const shouldUpdateScroll = checkedItemOffsetLeft - (navWidth / 2 - checkedItemWidth / 2) - 16;
    if (navigationBar.scrollWidth > navWidth) {
      // 如果导航条可以滚动，执行滚动操作
      navigationBar.scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
      // 顶部固定导航条也执行滚动操作
      document.querySelector('.tab-scroll').scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
    }
  }

  getTabTypeState = (tabType) => {
    return {
      isCapsuleTab: tabType === '胶囊Tab',
      isTextTab: tabType === '文字Tab',
      isImageTab: tabType !== '胶囊Tab' && tabType !== '文字Tab'
    };
  }

  getRootClassName = (tabTypeState) => {
    const { isCapsuleTab, isTextTab } = tabTypeState;
    let className = 'pipeline-tab';

    if (isCapsuleTab) {
      className += ' pipeline-tab--capsule capsule-type';
    } else if (isTextTab) {
      className += ' pipeline-tab--text text-type';
    } else {
      className += ' pipeline-tab--image img-type';
    }

    return className;
  }

  getTabItemClassName = (tabTypeState, adaptive, tabFixed, tabScroller) => {
    const { isCapsuleTab, isTextTab } = tabTypeState;
    let className = 'tab-item';

    if (isCapsuleTab) {
      className += ' tab-item--capsule capsule-tab-item';
    } else if (isTextTab) {
      className += ' tab-item--text type-text';
    } else {
      className += ' tab-item--image type-img';
    }

    if (adaptive && tabFixed) {
      className += ' is-fixed fixed';
    }

    if (tabScroller) {
      className += ' is-scroller scroller';
    }

    return className;
  }

  getTabScrollClassName = (tabTypeState, tabScroller) => {
    const { isCapsuleTab, isTextTab } = tabTypeState;
    let className = 'tab-scroll';

    if (isCapsuleTab) {
      className += ' tab-scroll--capsule';
    } else if (isTextTab) {
      className += ' tab-scroll--text';
    } else {
      className += ' tab-scroll--image';
    }

    if (tabScroller) {
      className += ' custom-padding';
    }

    return className;
  }

  getTabNavClassName = (tabTypeState, selected, index, tabScroller) => {
    const { isCapsuleTab, isTextTab } = tabTypeState;
    let className = 'tab-item-nav';

    if (isCapsuleTab) {
      className += ' tab-item-nav--capsule';
    } else if (isTextTab) {
      className += ' tab-item-nav--text';
    } else {
      className += ' tab-item-nav--image';
    }

    className += selected == index ? ' tab-item-nav-active active' : '';
    className += tabScroller ? ' customWidth' : ' autoWidth';

    return className;
  }

  getCapsuleTabNavStyle = (selected, index, tabBgColor, tabSelectedBgColor) => {
    const defaultTabBgColor = tabBgColor || '#E8EAEE';
    const defaultTabSelectedBgColor = tabSelectedBgColor || '#FFFFFF';

    return {
      backgroundColor: selected == index ? defaultTabSelectedBgColor : defaultTabBgColor,
      color: selected == index ? '#333' : '#666'
    };
  }

  renderImageTabNavContent = (item, selected, index) => {
    return <img src={selected == index ? item.tabTitle.selectedImg : item.tabTitle.unselectedImg} />;
  }

  renderTextTabNavContent = (item, selected, index, fontColor) => {
    return (
      <React.Fragment>
        <p
          style={{
            color: fontColor,
            opacity: selected == index ? 1 : .8,
          }}
        >
          {item.tabTitle.tabName}
        </p>
        {selected === index && <p className="underline" style={{backgroundColor: fontColor}}></p>}
      </React.Fragment>
    );
  }

  // 根据胶囊 Tab 数量限制标题文本的最大宽度，避免挤压布局。
  getCapsuleTabTextStyle = (grainsLength, active) => {
    if (grainsLength === 2 || grainsLength === 3) {
      return {
        maxWidth: active ? px2rem('96px') : px2rem('84px')
      };
    }

    if (grainsLength === 4) {
      return {
        maxWidth: active ? px2rem('64px') : px2rem('60px')
      };
    }

    return {};
  }

  renderCapsuleTabNavContent = (item, selected, index, grainsLength) => {
    const { fontColorCapsule, fontColorActiveCapsule } = this.props.config.baseConfig;
    return (
      <p
        style={{
          color: selected === index ? fontColorActiveCapsule : fontColorCapsule,
          ...this.getCapsuleTabTextStyle(grainsLength, selected === index)
        }}
      >
        {item.tabTitle.tabName}
      </p>
    );
  }

  renderTabNavContent = (item, index, selected, tabTypeState, fontColor, grainsLength) => {
    const { isCapsuleTab, isTextTab } = tabTypeState;

    if (isCapsuleTab) {
      return this.renderCapsuleTabNavContent(item, selected, index, grainsLength);
    }

    if (isTextTab) {
      return this.renderTextTabNavContent(item, selected, index, fontColor);
    }

    return this.renderImageTabNavContent(item, selected, index);
  }

  renderTabNavItem = (item, index, params) => {
    const { selected, tabScroller, tabTypeState, fontColor, tabBgColor, tabSelectedBgColor, grainsLength } = params;
    const { isCapsuleTab } = tabTypeState;

    return (
      <li
        ref={ele => {
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props, {
          sort: index
        }))}
        className={this.getTabNavClassName(tabTypeState, selected, index, tabScroller)}
        key={`tab-item-nav-${index}`}
        style={isCapsuleTab ? this.getCapsuleTabNavStyle(selected, index, tabBgColor, tabSelectedBgColor) : {}}
        onClick={(event) => this.handleTabSelect(event, item, index)}
      >
        {this.renderTabNavContent(item, index, selected, tabTypeState, fontColor, grainsLength)}
      </li>
    );
  }

  render() {
    const { osVersion = '', legoAb = '' } = this.props;
    const { isAndroid, selected, tabFixed, selectRecord = [0], reRender } = this.state;
    const { moduleMarginTop, tabType, fontColor, tabBgColor, tabSelectedBgColor } = this.props.config.baseConfig;
    const { grains } = this.props.config.containerConfig;
    if (!grains || grains.length <= 0) {
      return null;
    }
    const tabTypeState = this.getTabTypeState(tabType);
    const { isCapsuleTab, isTextTab } = tabTypeState;

    const navList = [];
    const pipelineTabItem = this.props.allComponents.filter(item => item.name === 'pipeline-tabItem');
    const pipelineFilterTabItem = this.props.allComponents.filter(item => item.name !== 'pipeline-tabItem');
    const findIndexPipelineTab = pipelineFilterTabItem.findIndex(item => item.name === 'pipeline-tab');
    let tabBarHeight = 0;
    let tabItemComponent = [];

    if (this.tabItemRef) {
      tabBarHeight = this.tabItemRef.clientHeight;
    }

    for (const [tabIndex, tabItem] of pipelineTabItem.entries()) {
      tabItem.data.forEach((item, index) => {
        if (item.name == 'pipeline-ab') {
          // if (!legoAb || typeof window == 'undefined') {
          //   // 将组件名置空，不进行渲染
          //   item.name = ''
          //   return
          // }
          const list = item.data || []
          list.forEach(comp => {
            if (comp.id.endsWith(`TEST_${legoAb}`)) {
              tabItem.data[index] = comp
              item = comp
            }
          })
        }
      });
      const Components = tabItem.data.map((oneComponent, index) => {
        if (
          ([
            'pipeline-product',
            'pipeline-goodsRecommend',
            'pipeline-rank',
            'pipeline-imgHotMap',
            'pipeline-community',
            'pipeline-communityArticle',
            'pipeline-pkRank',
            'pipeline-product-customize',
            'pipeline-productCollection',
            'pipeline-productGather',
            'pipeline-productLayout3',
            'pipeline-hotSellRankList'
          ].includes(oneComponent.name)) &&
            oneComponent.data &&
            oneComponent.data.baseConfig &&
            oneComponent.data.baseConfig.addToNav &&
            oneComponent.data.baseConfig.title &&
            navList.indexOf(oneComponent.data.baseConfig.title) === -1
        ) {
          navList.push({
            id: oneComponent.id,
            title: oneComponent.data.baseConfig.title
          });
        }
        if (oneComponent.name === 'pipeline-imgList' &&
          oneComponent.data &&
          oneComponent.data.baseConfig &&
          oneComponent.data.baseConfig.addToNav &&
          oneComponent.data.baseConfig.title
        ) {
          navList.push({
            id: oneComponent.id,
            title: oneComponent.data.baseConfig.title
          });
        }

        // 给Tab子组件添加blockName
        if (oneComponent.name && oneComponent.id && !oneComponent.blockName) {
          oneComponent.blockName = oneComponent.id
          let json = null
          try {
            json = require(`comp/${oneComponent.name}/package.json`)
          } catch (e) {
            console.log('not found')
          }
          if (json && json.pipeline) {
            oneComponent.blockName += `-${json.pipeline.title}`
            if (oneComponent.data && oneComponent.data.baseConfig && oneComponent.data.baseConfig.title) {
              oneComponent.blockName += `_${oneComponent.data.baseConfig.title}`
            }
          }
        }

        const otherProps = {
          isLastComponent: index === tabItem.data.length - 1,
          osVersion: this.props.osVersion
        }

        // 渲染Tab子组件
        const OneComponent = this.props.baseAllComponents[oneComponent.name];

        const { componentSize } = oneComponent.data;
        const containerStyle = {};
        // if (componentSize && componentSize.height !== "" && FixedHeightComps.indexOf(oneComponent.name) >= 0 && !this.isIframe) {
        //   Object.assign(containerStyle, {
        //     minHeight: oneComponent.name != 'pipeline-navigation' ? px2rem(`${componentSize.height}px`) : px2rem('40px')
        //   })
        // }

        return OneComponent && (
          <div className="component-wrapper" style={{...containerStyle}} key={`OneComponent-${index}`}>
            <OneComponent
              componentIndex={index}
              componentLength={tabItem.data.length}
              key={oneComponent.id}
              from={this.props.from}
              downloadUrl={this.props.downloadUrl}
              kouling={this.props.kouling}
              navList={navList}
              hasNavigation={this.props.hasNavigation}
              customAttributes={{
                "data-component-id": oneComponent.id,
                "data-component-name": oneComponent.name,
                "data-component-block": oneComponent.blockName,
                "data-component-belong": "tab"
              }}
              config={oneComponent.data}
              dataSourceStr={this.props.dataSourceStr}
              navigationBarHeight={this.props.navigationBarHeight + tabBarHeight - 0.5}
              navigationBarPaddingTop={this.props.navigationBarPaddingTop}
              routeParams={this.props.routeParams}
              webpSupport={this.props.webpSupport}
              backgroundColor={this.props.backgroundColor}
              templateName={this.props.templateName}
              allModals={this.props.allModals}
              templatePti={this.props.templatePti}
              tabChName={this.state.tabChName || grains[tabIndex].tabTitle.tabName}
              legoAb={this.props.legoAb}
              tabIndex={tabIndex}
              tabActive={selected}
              tabFixed={tabFixed}
              componentSize={componentSize}
              tabContainerBgColor={grains[selected].tabTitle.tabContainerBgColor}
              reRender={reRender}
              lotteryState={this.props.lotteryState}
              communityVoteState={this.props.communityVoteState}
              updateLotteryState={this.props.updateLotteryState}
              updateCommunityVoteState={this.props.updateCommunityVoteState}
              {...otherProps}
              exp={(ele) => {
                if (ele) {
                  this.props.exp && this.props.exp(ele);
                }
              }}
            />
          </div>
        );
      });
      tabItemComponent.push(Components)
    }
    let tabItemClass = "tab-item", tabScroller = false, adaptive = false;
    if (!isAndroid && (osVersion == '15.1' || osVersion == '15.2')) {
      adaptive = true
    }
    if (isTextTab || isCapsuleTab) {
      if (grains.length >= 5) {
        tabScroller = true;
      }
    } else {
      if (grains.length > 5) {
        tabScroller = true;
      }
    }
    tabItemClass = this.getTabItemClassName(tabTypeState, adaptive, tabFixed, tabScroller);
    // 计算tabItem区域的最小高度
    let contentHeight = screenHeight;
    const pipelineTab = document.querySelector('.pipeline-tab');
    const tabScroll =  document.querySelector('.tab-scroll');
    const navigationBarWrapper = document.querySelector('.navigation-bar-wrapper');
    // if (navigationBarWrapper) {
    //   contentHeight = contentHeight - navigationBarWrapper.clientHeight;
    // }
    // if (pipelineTab && tabScroll) {
    //   contentHeight = contentHeight - pipelineTab.offsetTop - tabScroll.clientHeight;
    // }
    return (
      <div
        ref={ref => this.pipelineTabRef = ref}
        className={this.getRootClassName(tabTypeState)}
        {...this.props['customAttributes']}
        style={{
          paddingTop: moduleMarginTop >= 0 ? `${moduleMarginTop}px` : 0,
          marginTop: moduleMarginTop < 0 ? `${moduleMarginTop}px` : 0
        }}
      >
        {
          adaptive ? (
            tabFixed && <div ref={ref => this.tabItemPlaceholderRef = ref} className="placeholder tab-item-placeholder" style={{height: tabBarHeight}}></div>
          ) : (
            <div ref={ref => this.tabItemPlaceholderRef = ref}  className="placeholder tab-item-placeholder"></div>
          )
        }
        <div
          ref={ref => this.tabItemRef = ref}
          className={`${tabItemClass} tab-nav`}
          style={{
            top: this.props.navigationBarHeight,
            backgroundColor: isCapsuleTab && tabFixed ? '#FFF' : this.props.backgroundColor,
            borderRadius: isCapsuleTab && !tabFixed ? `${px2rem('12px')} ${px2rem('12px')} 0 0` : undefined
          }}
        >
          <ul className={this.getTabScrollClassName(tabTypeState, tabScroller)}>
            {
              grains.map((item, index) => this.renderTabNavItem(item, index, {
                selected,
                tabScroller,
                tabTypeState,
                fontColor,
                tabBgColor,
                tabSelectedBgColor,
                grainsLength: grains.length
              }))
            }
          </ul>
        </div>
        <div ref={ref => this.tabItemContentRef = ref} className="tab-item-content tab-content" style={{ backgroundColor: grains[selected].tabTitle.tabContainerBgColor, minHeight: contentHeight }}>
          {
            tabItemComponent.map((item, index) => {
              const hasRecord = selectRecord.findIndex(item => item === index)
              if (hasRecord >= 0) {
                return (
                  <div
                    data-component-id={pipelineTabItem[index] && pipelineTabItem[index]['id']}
                    data-component-name={pipelineTabItem[index] && pipelineTabItem[index]['name']}
                    key={`tab-container-${index}`}
                    className={selected == index ? `tab-container ${this.isIframe ? 'iframe' : 'app'} show` : `tab-container ${this.isIframe ? 'iframe' : 'app'} hide`}
                  >
                    {item}
                  </div>
                ) 
              } else {
                return (
                  <div
                    data-component-id={pipelineTabItem[index] && pipelineTabItem[index]['id']}
                    data-component-name={pipelineTabItem[index] && pipelineTabItem[index]['name']}
                    key={`tab-container-${index}`}
                    className={selected == index ? `tab-container ${this.isIframe ? 'iframe' : 'app'} show` : `tab-container ${this.isIframe ? 'iframe' : 'app'} hide`}
                  >
                    { this.isIframe ? item : null }
                  </div>
                )
              }
            })
          }
        </div>
      </div>
    );
  }
}

PipelineTab.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineTab };
export default PipelineTab;



// WEBPACK FOOTER //
// ./components/pipeline-tab/index.js